// extracted by mini-css-extract-plugin
module.exports = {"cart":"PaymentCart_cart__2G3yM","amt":"PaymentCart_amt__34d8u","promoCodeForm":"PaymentCart_promoCodeForm__16HrS"};